import React from 'react';
import $ from 'jquery';
import { PropTypes } from 'prop-types';
import { inject, observer } from 'mobx-react';
import MortgageFormComponent from './MortgageFormComponent';
import LoanpartFormComponent from './LoanpartFormComponent';
import PrimaryButtonComponent from '../../shared_components/buttons/PrimaryButtonComponent';
import AddLoanpartComponent from './AddLoanpartComponent';
import MortgageLoanpartsDifferenceComponent from '../../shared_components/MortgageLoanpartsDifferenceComponent';
import ErrorAlertComponent from '../../shared_components/ErrorAlertComponent';
import InfoAlertComponent from '../../shared_components/InfoAlertComponent';
import ToggleComponent from '../../shared_components/ToggleComponent';
import LabelHasRiskClassReductionLogoComponent from './LabelHasRiskClassReductionLogoComponent';


@observer
class CalculationFormComponent extends React.Component {
  constructor(props) {
    super(props);
    this.calculateLoanparts = this.calculateLoanparts.bind(this);
    this.toggleAutoRiskClassReduction = this.toggleAutoRiskClassReduction.bind(this);
  }

  calculateLoanparts() {
    const {
      calculateLoanpartsWithoutForceAutoRiskClassReduction,
    } = this.props.CalculationOutputData;

    const {
      forceAutoRiskClassReduction,
    } = this.props.CalculationFormData.mortgageForm;

    this.props.CalculationOutputData.calculateLoanparts().then((response) => {
      if (response && response.status === 200) {
        const $calculationOutputPanel = $('.calculation-container--calculation-output-panel');

        if (forceAutoRiskClassReduction) {
          calculateLoanpartsWithoutForceAutoRiskClassReduction();
        }

        if ($calculationOutputPanel.length > 0) {
          $('html, body').animate({ scrollTop: $calculationOutputPanel.offset().top }, 600);
        }
      }
    });
  }

  toggleAutoRiskClassReduction() {
    this.props.CalculationFormData.toggleForceAutoRiskClassReduction();
  }

  render() {
    const {
      loanparts,
      labelId,
      mortgage,
      forceAutoRiskClassReduction,
      providerId,
    } = this.props.CalculationFormData.mortgageForm;
    const {
      responseError,
      errorFields,
      selectedLabelHasAutoRiskClassReduction,
      responseErrorFields,
      showNhgAlertInfo,
      addLoanpart,
    } = this.props.CalculationFormData;

    const {
      mortgageLoanpartsDifference,
    } = this.props.CalculationOutputData;

    const {
      showToolTip,
      hideToolTip,
      toolTipVisible,
      toggleToolTip,
    } = this.props.ToolTipData;

    const {
      regulationNhg,
      regulationNhgWithEBM,
    } = this.props.NhgRegulationData;

    const {
      ProviderLabelData,
    } = this.props;

    const labelHasAutoRiskClassReduction = selectedLabelHasAutoRiskClassReduction();

    let responseNhgInfoAlertText = '';

    if (showNhgAlertInfo) {
      responseNhgInfoAlertText = (<div>Let op: De maximale hypotheek met NHG bedraagt € {regulationNhg},- en de
        maximale hypotheek met NHG en energiebesparende maatregelen bedraagt € {regulationNhgWithEBM},-.</div>);
    }
    let disclaimerText = '';
    if (forceAutoRiskClassReduction && !labelHasAutoRiskClassReduction) {
      disclaimerText = (
        <div>
          <span className="bold">Let op:</span>
          <ul>
            <li>
              Dit product heeft geen looptijdrente. Aan het einde van de rentevaste periode wordt de rente wel
              aangepast aan de geldende risicoklasse (schuld/woningwaarde verhouding).
            </li>
            <li>
              Omdat u nu gekozen heeft voor ja, doen wij alsof dit product wel
              looptijdrente heeft.
            </li>
          </ul>
          <br />
          <p>De weergave van de maandlasten is een indicatie in het geval dat:</p>
          <ul>
            <li>
              Dit product wel looptijdrente zou hebben;
            </li>
            <li>
              De klant zich steeds bij de aanbieder zou melden zodra de risicoklasse (schuld/woningwaarde verhouding)
              daalt.
            </li>
          </ul>
        </div>
      );
    }
    return (
      <div className="calculation-form">
        <ErrorAlertComponent
          show={responseError || responseErrorFields}
          responseError={responseError || responseErrorFields}
          errorFields={errorFields}
        />

        <InfoAlertComponent
          show={showNhgAlertInfo}
          text={responseNhgInfoAlertText}
        />

        <MortgageFormComponent />

        <LoanpartFormComponent
          show={loanparts.length > 0 && labelId > 0}
        />

        <div className="calculation-form__add-loanpart">
          <AddLoanpartComponent
            onClickHandler={addLoanpart}
            show={loanparts.length < 3}
          />
        </div>

        <div className="calculation-form__mortgage-difference">
          <MortgageLoanpartsDifferenceComponent
            loanparts={loanparts}
            mortgage={mortgage}
            toggleToolTip={toggleToolTip}
            showToolTip={showToolTip}
            hideToolTip={hideToolTip}
            toolTipVisible={toolTipVisible}
            show={mortgageLoanpartsDifference}
            difference={mortgageLoanpartsDifference}
          />
        </div>

        <div className="tool-row columns">
          <div className="medium-15 columns float-right">
            <PrimaryButtonComponent
              text={'Bereken'}
              show={loanparts.length > 0 && labelId > 0}
              disabled={loanparts.length > 1 && providerId === 400} // jungo only supports 1 loanpart
              title={(loanparts.length > 1 && providerId === 400) ?
                'Bij Jungo kunt u maximaal 1 leningdeel opgeven' : ''}
              onClickHandler={this.calculateLoanparts}
            />
          </div>
          <div className="medium-40 small-45 large-30 columns float-right">
            <ToggleComponent
              show={!labelHasAutoRiskClassReduction && ProviderLabelData.labels.length > 0
              && ProviderLabelData.providers.length > 0}
              handleInputChange={this.toggleAutoRiskClassReduction}
              checked={forceAutoRiskClassReduction}
              id={'toggle-rateClassReduction'}
              classNames={'toggle-autoRiskClass'}
            />
            <LabelHasRiskClassReductionLogoComponent
              show={ProviderLabelData.labels.length > 0 && ProviderLabelData.providers.length > 0}
              selectedLabelHasAutoRiskClassReduction={labelHasAutoRiskClassReduction}
              forceAutoRiskClassReduction={forceAutoRiskClassReduction}
            />

          </div>
        </div>
        <div className="tool-row calculation-form__disclaimer">
          <InfoAlertComponent
            show={!labelHasAutoRiskClassReduction && disclaimerText}
            text={disclaimerText}
          />
        </div>
      </div>
    );
  }
}

CalculationFormComponent.propTypes = {
  ToolTipData: PropTypes.shape({
    showToolTip: PropTypes.func,
    hideToolTip: PropTypes.func,
    toggleToolTip: PropTypes.func,
    toolTipVisible: PropTypes.bool,
  }),
  CalculationOutputData: PropTypes.shape({
    calculateLoanparts: PropTypes.func,
    mortgageLoanpartsDifference: PropTypes.number,
    calculateLoanpartsWithoutForceAutoRiskClassReduction: PropTypes.func,
  }),
  NhgRegulationData: PropTypes.shape({
    regulationNhgWithEBM: PropTypes.string,
    regulationNhg: PropTypes.string,
  }),
  ProviderLabelData: PropTypes.shape({}).isRequired,
  CalculationFormData: PropTypes.shape({
    forceAutoRiskClassReduction: PropTypes.bool,
    addLoanpart: PropTypes.func,
    mortgage: PropTypes.number,
    removeLoanpart: PropTypes.func,
    selectedLabelHasAutoRiskClassReduction: PropTypes.func,
    showRiskClassReductionSwitch: PropTypes.bool,
    responseError: PropTypes.string,
    responseErrorFields: PropTypes.string,
    errorFields: PropTypes.arrayOf(PropTypes.shape({})),
    showNhgAlertInfo: PropTypes.bool,
    mortgageForm: PropTypes.shape({
      forceAutoRiskClassReduction: PropTypes.bool,
      mortgage: PropTypes.number,
      loanparts: PropTypes.arrayOf(PropTypes.number),
      labelId: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.number,
      ]),
    }),
    toggleForceAutoRiskClassReduction: PropTypes.func,
  }),
};

CalculationFormComponent.defaultProps = {
  ToolTipData: {
    showToolTip: () => {
    },
    hideToolTip: () => {
    },
    toggleToolTip: () => {
    },
    toolTipVisible: false,
  },
  NhgRegulationData: {
    regulationNhgWithEBM: '',
    regulationNhg: '',
  },
  CalculationOutputData: {
    calculateLoanpartsWithoutForceAutoRiskClassReduction: () => {
    },
    calculateLoanparts: () => {
    },
  },
  CalculationFormData: {
    selectedLabelHasAutoRiskClassReduction: () => {
    },
    forceAutoRiskClassReduction: false,
    addLoanpart: () => {
    },
    removeLoanpart: () => {
    },
    errorFields: [],
    responseErrorFields: '',
    mortgageForm: {
      mortgage: 0,
      loanparts: [],
      labelId: '',
    },
    toggleForceAutoRiskClassReduction: () => {
    },
  },
};

export default inject('CalculationFormData',
  'CalculationOutputData',
  'ToolTipData',
  'ProviderLabelData',
  'NhgRegulationData')(CalculationFormComponent);
